// src/components/Reports.js
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaChartBar, FaDownload } from 'react-icons/fa';

const Reports = () => {
    const navigate = useNavigate();
    const { tasks } = useSelector(state => state.tasks);

    const generateReport = () => {
        const reportData = tasks.map(task => ({
            Title: task.title,
            Status: task.status,
            Priority: task.priority_score,
            Importance: task.importance,
            Urgency: task.urgency,
            Complexity: task.complexity,
            'Estimated Hours': task.estimated_hours,
            Assignee: task.assignee || 'Unassigned',
            'Created At': new Date(task.created_at).toLocaleDateString()
        }));

        const csvContent = [
            Object.keys(reportData[0]).join(','),
            ...reportData.map(row => Object.values(row).join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `task-report-${new Date().toISOString().split('T')[0]}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const stats = {
        total: tasks.length,
        completed: tasks.filter(t => t.status === 'completed').length,
        pending: tasks.filter(t => t.status === 'pending').length,
        highPriority: tasks.filter(t => t.priority_score >= 8).length,
        avgPriority: tasks.length > 0 ? (tasks.reduce((sum, t) => sum + t.priority_score, 0) / tasks.length).toFixed(2) : 0
    };

    return (
        <div className="reports-container">
            <div className="reports-header">
                <button className="back-button" onClick={() => navigate(-1)}>
                    <FaArrowLeft /> Back
                </button>
                <h1><FaChartBar /> Task Reports</h1>
            </div>

            <div className="reports-content">
                <div className="report-stats">
                    <div className="stat-card">
                        <h3>Total Tasks</h3>
                        <p>{stats.total}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Completed</h3>
                        <p>{stats.completed}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Pending</h3>
                        <p>{stats.pending}</p>
                    </div>
                    <div className="stat-card">
                        <h3>High Priority</h3>
                        <p>{stats.highPriority}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Avg Priority</h3>
                        <p>{stats.avgPriority}</p>
                    </div>
                </div>

                <div className="report-actions">
                    <button className="btn btn-primary" onClick={generateReport}>
                        <FaDownload /> Download CSV Report
                    </button>
                </div>
            </div>

            <style jsx>{`
                .reports-container {
                    max-width: 1000px;
                    margin: 0 auto;
                    padding: 20px;
                }

                .reports-header {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    margin-bottom: 30px;
                }

                .back-button {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    background: #6c757d;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 6px;
                    cursor: pointer;
                }

                .reports-content {
                    background: white;
                    border-radius: 12px;
                    padding: 30px;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
                }

                .report-stats {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 20px;
                    margin-bottom: 30px;
                }

                .stat-card {
                    background: #f8f9fa;
                    padding: 20px;
                    border-radius: 8px;
                    text-align: center;
                    border: 2px solid #e9ecef;
                }

                .stat-card h3 {
                    margin: 0 0 10px 0;
                    color: #495057;
                    font-size: 14px;
                    text-transform: uppercase;
                }

                .stat-card p {
                    margin: 0;
                    font-size: 32px;
                    font-weight: bold;
                    color: #667eea;
                }

                .report-actions {
                    text-align: center;
                    padding-top: 20px;
                    border-top: 1px solid #e9ecef;
                }

                .btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 12px 24px;
                    border: none;
                    border-radius: 6px;
                    cursor: pointer;
                    font-weight: 600;
                    background: #667eea;
                    color: white;
                    transition: background 0.3s;
                }

                .btn:hover {
                    background: #5a6fd8;
                }
            `}</style>
        </div>
    );
};

export default Reports;